/*
  NFCARD · Vista 3D del editor de tarjetas
  ---------------------------------------------------------------
  Lo carga sections/nfcard-vista3d.liquid, que va en la misma página
  que sections/nfcard-editor.liquid. Añade el botón «Vista 3D» a la
  barra del editor y enseña la tarjeta en 3D con las dos caras tal
  como las pinta el editor (mismo código que el archivo de impresión).

  El modelo de la tarjeta es un GLB que se genera aquí con las medidas
  reales (CR80, 0,84 mm de grosor) y se muestra con <model-viewer>
  (assets/nfcard-model-viewer.js, licencia Apache 2.0), que solo se
  descarga cuando el cliente abre la vista 3D.
*/
(function () {
  'use strict';

  var MM = 0.001;
  var GROSOR = 0.84;
  var RADIO_ESQUINA = 3.18;
  var SANGRADO = 2;
  var PPP = 220;
  var TRAMOS_ESQUINA = 8;
  var ORBITA = { a: '-25deg 78deg auto', r: '155deg 78deg auto' };
  var CANTO = { color: '#F2F2EF', metal: '#0B0B0C' };

  function el(tag, attrs, hijos) {
    var n = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) {
      var v = attrs[k];
      if (v === null || v === undefined || v === false) return;
      if (k === 'class') n.className = v;
      else if (k === 'text') n.textContent = v;
      else n.setAttribute(k, v === true ? '' : v);
    });
    (hijos || []).forEach(function (h) { if (h) n.appendChild(h); });
    return n;
  }

  /* ------------------------------------------------------------------
     Modelo: tarjeta de W x H mm como GLB, con tres materiales
     («Anverso», «Reverso» y «Canto»). Las caras llevan UV de 0 a 1
     sobre la tarjeta ya cortada; el reverso va espejado para que se
     lea bien al darle la vuelta.
  ------------------------------------------------------------------ */
  function glbTarjeta(anchoMM, altoMM) {
    var W = anchoMM * MM, H = altoMM * MM, R = RADIO_ESQUINA * MM, z = GROSOR * MM / 2;
    var borde = [];
    [[W / 2 - R, H / 2 - R, 0], [-W / 2 + R, H / 2 - R, 90], [-W / 2 + R, -H / 2 + R, 180], [W / 2 - R, -H / 2 + R, 270]].forEach(function (c) {
      for (var i = 0; i <= TRAMOS_ESQUINA; i++) {
        var a = (c[2] + 90 * i / TRAMOS_ESQUINA) * Math.PI / 180;
        borde.push({ x: c[0] + R * Math.cos(a), y: c[1] + R * Math.sin(a), nx: Math.cos(a), ny: Math.sin(a) });
      }
    });
    var n = borde.length;

    function cara(signo) {
      var pos = [0, 0, signo * z], nor = [0, 0, signo], uv = [0.5, 0.5], idx = [];
      borde.forEach(function (p, i) {
        var u = (p.x + W / 2) / W;
        pos.push(p.x, p.y, signo * z); nor.push(0, 0, signo);
        uv.push(signo > 0 ? u : 1 - u, 1 - (p.y + H / 2) / H);
        var a = 1 + i, b = 1 + (i + 1) % n;
        if (signo > 0) idx.push(0, a, b); else idx.push(0, b, a);
      });
      return { pos: pos, nor: nor, uv: uv, idx: idx };
    }
    function canto() {
      var pos = [], nor = [], idx = [];
      borde.forEach(function (p, i) {
        pos.push(p.x, p.y, z, p.x, p.y, -z); nor.push(p.nx, p.ny, 0, p.nx, p.ny, 0);
        var a = 2 * i, b = 2 * ((i + 1) % n);
        idx.push(a, a + 1, b + 1, a, b + 1, b);
      });
      return { pos: pos, nor: nor, idx: idx };
    }

    var trozos = [], largo = 0, vistas = [], accesores = [];
    function anade(datos, tipo, destino, extra) {
      var comps = { SCALAR: 1, VEC2: 2, VEC3: 3 }[tipo];
      var indices = tipo === 'SCALAR';
      var arr = indices ? new Uint16Array(datos) : new Float32Array(datos);
      vistas.push({ buffer: 0, byteOffset: largo, byteLength: arr.byteLength, target: destino });
      var acc = { bufferView: vistas.length - 1, componentType: indices ? 5123 : 5126, count: datos.length / comps, type: tipo };
      if (extra) { acc.min = extra.min; acc.max = extra.max; }
      accesores.push(acc);
      trozos.push(arr);
      largo += arr.byteLength + (4 - arr.byteLength % 4) % 4;
      return accesores.length - 1;
    }
    var limites = { min: [-W / 2, -H / 2, -z], max: [W / 2, H / 2, z] };
    var primitivas = [cara(1), cara(-1), canto()].map(function (g, i) {
      var atributos = { POSITION: anade(g.pos, 'VEC3', 34962, limites), NORMAL: anade(g.nor, 'VEC3', 34962) };
      if (g.uv) atributos.TEXCOORD_0 = anade(g.uv, 'VEC2', 34962);
      return { attributes: atributos, indices: anade(g.idx, 'SCALAR', 34963), material: i };
    });
    function material(nombre, color) {
      return { name: nombre, pbrMetallicRoughness: { baseColorFactor: color, metallicFactor: 0, roughnessFactor: 0.42 } };
    }
    var json = JSON.stringify({
      asset: { version: '2.0', generator: 'NFCARD' },
      scene: 0, scenes: [{ nodes: [0] }], nodes: [{ name: 'Tarjeta', mesh: 0 }],
      meshes: [{ name: 'Tarjeta', primitives: primitivas }],
      materials: [material('Anverso', [1, 1, 1, 1]), material('Reverso', [1, 1, 1, 1]), material('Canto', [0.89, 0.89, 0.86, 1])],
      accessors: accesores, bufferViews: vistas, buffers: [{ byteLength: largo }]
    });
    var texto = new TextEncoder().encode(json);
    var largoJson = texto.length + (4 - texto.length % 4) % 4;
    var glb = new ArrayBuffer(12 + 8 + largoJson + 8 + largo);
    var dv = new DataView(glb), bytes = new Uint8Array(glb);
    dv.setUint32(0, 0x46546C67, true); dv.setUint32(4, 2, true); dv.setUint32(8, glb.byteLength, true);
    dv.setUint32(12, largoJson, true); dv.setUint32(16, 0x4E4F534A, true);
    bytes.fill(0x20, 20, 20 + largoJson); bytes.set(texto, 20);
    var p = 20 + largoJson;
    dv.setUint32(p, largo, true); dv.setUint32(p + 4, 0x004E4942, true);
    p += 8;
    trozos.forEach(function (arr, i) { bytes.set(new Uint8Array(arr.buffer), p + vistas[i].byteOffset); });
    return new Blob([glb], { type: 'model/gltf-binary' });
  }

  /* ------------------------------------------------------------------
     <model-viewer>: se descarga la primera vez que se abre la vista
  ------------------------------------------------------------------ */
  var cargando = null;
  function cargaVisor(url) {
    if (window.customElements.get('model-viewer')) return Promise.resolve();
    if (!cargando) {
      cargando = new Promise(function (ok, mal) {
        var s = el('script', { type: 'module', src: url });
        s.onerror = function () { cargando = null; s.remove(); mal(new Error('model-viewer')); };
        window.customElements.whenDefined('model-viewer').then(ok);
        document.head.appendChild(s);
      });
    }
    return cargando;
  }

  /* ------------------------------------------------------------------
     Vista
  ------------------------------------------------------------------ */
  function Vista(raiz, editor, cfg) {
    this.raiz = raiz;
    this.ed = editor;
    this.cfg = cfg;
    this.abierta = false;
    this.listo = false;
    this.turno = 0;
    this.montar();
  }

  Vista.prototype.montar = function () {
    var self = this, R = this.raiz, cfg = this.cfg;
    var barra = R.querySelector('.ne-barra'), lienzo = R.querySelector('[data-lienzo]');
    if (!barra || !lienzo) return;

    this.btn = el('button', { type: 'button', class: 'ne-3d-btn', 'data-accion': 'vista3d', 'aria-pressed': 'false', text: cfg.etiqueta });
    this.btn.addEventListener('click', function () { if (self.abierta) self.cerrar(); else self.abrir(); });
    barra.appendChild(this.btn);

    this.escena = el('div', { class: 'ne-3d__escena' });
    this.estado = el('p', { class: 'ne-3d__estado', role: 'status' });
    var cerrar = el('button', { type: 'button', class: 'ne-btn ne-btn--linea', text: cfg.cerrar });
    cerrar.addEventListener('click', function () { self.cerrar(); });
    this.capa = el('div', { class: 'ne-3d', role: 'region', 'aria-label': cfg.etiqueta, hidden: true }, [
      this.escena, this.estado,
      el('div', { class: 'ne-3d__pie' }, [el('span', { text: cfg.ayuda }), cerrar])
    ]);
    this.capa.addEventListener('keydown', function (e) { if (e.key === 'Escape') self.cerrar(); });
    lienzo.appendChild(this.capa);

    /* el editor repinta las miniaturas en cada cambio: es el aviso para repintar aquí */
    var ed = this.ed, miniaturas = ed.programaMiniaturas;
    ed.programaMiniaturas = function () {
      miniaturas.apply(ed, arguments);
      self.programa();
    };
  };

  Vista.prototype.abrir = function () {
    var self = this;
    this.abierta = true;
    this.capa.hidden = false;
    this.btn.classList.add('is-on');
    this.btn.setAttribute('aria-pressed', 'true');
    if (this.mv) { this.actualiza(); return; }
    this.estado.textContent = this.cfg.cargando;
    cargaVisor(this.cfg.visor).then(function () {
      if (self.mv) return;
      self.mv = el('model-viewer', {
        alt: self.cfg.alt, 'camera-controls': true, 'disable-pan': true, 'touch-action': 'pan-y',
        'interaction-prompt': 'none', 'camera-orbit': ORBITA[self.ed.st.cara] || ORBITA.a,
        'tone-mapping': 'neutral', 'shadow-intensity': '0.7', 'shadow-softness': '1'
      });
      self.mv.addEventListener('load', function () {
        self.listo = true;
        self.estado.textContent = '';
        self.actualiza();
      });
      self.mv.addEventListener('error', function () { self.estado.textContent = self.cfg.error; });
      self.escena.appendChild(self.mv);
      self.actualiza();
    }).catch(function () { self.estado.textContent = self.cfg.error; });
  };

  Vista.prototype.cerrar = function () {
    this.abierta = false;
    this.capa.hidden = true;
    this.btn.classList.remove('is-on');
    this.btn.setAttribute('aria-pressed', 'false');
    this.btn.focus();
  };

  Vista.prototype.programa = function () {
    var self = this;
    if (!this.abierta || !this.mv) return;
    clearTimeout(this._espera);
    this._espera = setTimeout(function () { self.actualiza(); }, 160);
  };

  /* quita el sangrado: la cara 3D es la tarjeta ya cortada */
  Vista.prototype.recorta = function (cv) {
    var m = this.ed.medidas(), s = Math.round(SANGRADO * PPP / 25.4);
    var w = Math.round(m.W * PPP / 25.4), h = Math.round(m.H * PPP / 25.4);
    var c = el('canvas', { width: w, height: h });
    c.getContext('2d').drawImage(cv, s, s, w, h, 0, 0, w, h);
    return c;
  };

  /* stamping: lo impreso brilla como metal y el negro de la tarjeta queda satinado.
     Canales glTF: verde = rugosidad, azul = metal. */
  Vista.prototype.mapaMetal = function (cv) {
    var c = el('canvas', { width: cv.width, height: cv.height });
    var ctx = c.getContext('2d');
    ctx.drawImage(cv, 0, 0);
    var img = ctx.getImageData(0, 0, c.width, c.height), d = img.data;
    for (var i = 0; i < d.length; i += 4) {
      var luz = 0.299 * d[i] + 0.587 * d[i + 1] + 0.114 * d[i + 2];
      var t = Math.max(0, Math.min(1, (luz - 24) / 60));
      d[i] = 255; d[i + 1] = Math.round(120 - 50 * t); d[i + 2] = Math.round(255 * t); d[i + 3] = 255;
    }
    ctx.putImageData(img, 0, 0);
    return c;
  };

  Vista.prototype.actualiza = function () {
    var self = this, ed = this.ed, st = ed.st, mv = this.mv;
    if (!this.abierta || !mv) return;

    if (st.orient !== this.orient) {
      var m = ed.medidas();
      this.orient = st.orient;
      this.listo = false;
      if (this.url) URL.revokeObjectURL(this.url);
      this.url = URL.createObjectURL(glbTarjeta(m.W, m.H));
      mv.src = this.url;
      return;
    }
    if (!this.listo || !mv.model) return;

    if (st.cara !== this.cara) {
      this.cara = st.cara;
      mv.cameraOrbit = ORBITA[st.cara] || ORBITA.a;
    }

    var metal = ed.esMetal(), turno = ++this.turno;
    [['a', 'Anverso'], ['r', 'Reverso']].forEach(function (par) {
      var mat = mv.model.getMaterialByName(par[1]);
      if (!mat) return;
      var pbr = mat.pbrMetallicRoughness;
      var cara = self.recorta(ed.exporta(par[0], PPP));
      var texturas = [mv.createTexture(cara.toDataURL('image/png'))];
      if (metal) texturas.push(mv.createTexture(self.mapaMetal(cara).toDataURL('image/png')));
      Promise.all(texturas).then(function (t) {
        if (turno !== self.turno) return;
        pbr.baseColorTexture.setTexture(t[0]);
        pbr.metallicRoughnessTexture.setTexture(t[1] || null);
        pbr.setMetallicFactor(metal ? 1 : 0);
        pbr.setRoughnessFactor(metal ? 1 : 0.42);
      }).catch(function () { self.estado.textContent = self.cfg.error; });
    });
    var canto = mv.model.getMaterialByName('Canto');
    if (canto) canto.pbrMetallicRoughness.setBaseColorFactor(metal ? CANTO.metal : CANTO.color);
  };

  /* ------------------------------------------------------------------
     Arranque
  ------------------------------------------------------------------ */
  function iniciar() {
    var datos = document.querySelector('[data-nfcard-vista3d]');
    if (!datos) return;
    Array.prototype.forEach.call(document.querySelectorAll('[data-nfcard-editor]'), function (raiz) {
      if (raiz.__vista3d || !raiz.__editor) return;
      raiz.__vista3d = new Vista(raiz, raiz.__editor, {
        visor: datos.getAttribute('data-visor'),
        etiqueta: datos.getAttribute('data-etiqueta') || 'Vista 3D',
        ayuda: datos.getAttribute('data-ayuda') || '',
        cerrar: datos.getAttribute('data-cerrar') || 'Volver al editor',
        cargando: 'Cargando la vista 3D…',
        error: 'No se ha podido cargar la vista 3D. Tu diseño no se ha perdido.',
        alt: 'Vista previa en 3D de tu tarjeta'
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
  window.addEventListener('load', iniciar);
  document.addEventListener('shopify:section:load', function () { setTimeout(iniciar, 0); });
})();
